import { ChangeEvent, memo } from 'react'
import { ResumeEducation } from 'packages/types'
import { AsyncAutosuggest, createSuggestionsApiFetcher } from 'builder/components/AsyncAutosuggest'
import { Base, CardComponentProps } from 'builder/components/Card'
import DateRangePicker from 'builder/components/DateRangePicker'
import { TextField } from 'builder/components/TextField'
import { i18n } from 'builder/utils/i18n'
import { formatDateRange } from 'builder/utils/formatDateRange'

import { CardContentWrapper, Field, Row } from 'builder/components/Card/styles'
import { DateRangePickerChangeValue } from 'builder/components/DateRangePicker/types'
import { withAutoFocus } from '../../../../../hocs/AutoFocusHoc'

const Education = memo((props: CardComponentProps<ResumeEducation>) => {
  const { item, locale, autoFocus } = props
  const titleDates = formatDateRange(item)
  const joiningString = ' ' + i18n.t('builder.resume_editor.labels.at') + ' '

  const title =
    [item.degree, item.school].filter(x => x).join(joiningString) ||
    i18n.t('builder.resume_editor.not_specified')

  const updateSimpleField = (e: ChangeEvent<HTMLInputElement>) => {
    const { onChange, sectionId, item } = props
    onChange(sectionId, item.id, { [e.target.name]: e.target.value }, true)
  }

  const updateDateRange = (val: DateRangePickerChangeValue) => {
    const { onChange, sectionId, item } = props
    onChange(sectionId, item.id, val, true)
  }

  return (
    <Base title={title} subtitle={titleDates} {...props}>
      <CardContentWrapper>
        <Row>
          <Field>
            <DateRangePicker
              value={item}
              onChange={updateDateRange}
              currentlyLabel={i18n.t('builder.date_range_picker.currently.study')}
            />
          </Field>

          <Field>
            <AsyncAutosuggest
              name="school"
              fetchItems={createSuggestionsApiFetcher('university', { limit: 4, locale })}
              value={item.school || ''}
              onChange={updateSimpleField}
            >
              {({ key, ...inputProps }) => (
                <TextField
                  {...inputProps}
                  key={key}
                  autoFocus={autoFocus}
                  label={i18n.t('builder.resume_editor.educations_card.school')}
                />
              )}
            </AsyncAutosuggest>
          </Field>
        </Row>

        <Row>
          <Field>
            <TextField
              label={i18n.t('builder.resume_editor.educations_card.faculty')}
              name="faculty"
              onChange={updateSimpleField}
              value={item.faculty || ''}
            />
          </Field>

          <Field>
            <TextField
              label={i18n.t('builder.resume_editor.educations_card.department')}
              name="department"
              onChange={updateSimpleField}
              value={item.department || ''}
            />
          </Field>
        </Row>
      </CardContentWrapper>
    </Base>
  )
})

export const EducationCard = withAutoFocus(Education)
